/* eslint-disable no-console */
import React, { useContext, useEffect, useState } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import PortableWifiOffIcon from '@mui/icons-material/PortableWifiOff';

import getI18nService from '../../i18n/i18n';
import Footer from '../includes/Footer';

const i18n = getI18nService();
const PassThroughError = () => {
  const theme = useTheme();
  return (
    <Paper
      id="test_guest_passThroughError"
      elevation={0}
      sx={{
        borderRadius: 2,
        backgroundColor: '#000000',
        m: 2,
        mt: 10,
        boxShadow: 'rgb(0 0 0 / 25%) 2px 4px 10px 4px',
        // border: '1px solid rgb(81, 81, 81)',
        opacity: 0.9,
      }}
    >
      <Container maxWidth={false}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignContent: 'center',
            alignItems: 'center',
            m: 2,
          }}
        >
          <Box sx={{ textAlign: 'center', p: 1, fontSize: 'h5.fontSize' }}>{i18n.t('Messages.retryMessage')}</Box>
          <PortableWifiOffIcon sx={{ fontSize: '64px', color: theme.palette.primary.main }} />
        </Box>
      </Container>
      <Footer />
    </Paper>
  );
};

PassThroughError.propTypes = {
  // title: PropTypes.string.isRequired,
};

export default PassThroughError;
